import React from 'react'
import Logo from '!!@svgr/webpack!media/chlorophyll/LS_logo_white_2022.svg'
import { FormattedMessage } from 'react-intl'
import AppButtons from 'js/components/AppButtons/AppButtons'

type Props = {
  onDismiss: () => void
}

const ChlorophyllSplashScreen = ({ onDismiss }: Props) => (
  <div className="z-20 bg-beige fixed inset-0 text-TypeConstant overflow-y-auto">
    <div className="flex flex-col h-full">
      <div className="chlorophyll-splash-screen__bg py-32 flex-grow flex w-full h-full flex-col justify-center text-center px-24">
        <div className="mx-auto px-32" style={{ maxWidth: 384 + 32 * 2 }}>
          <Logo className="w-full mb-32" height="100%" width="100%" />
        </div>
        <h1 className="w-auto md:text-48 text-36 mb-8 quincy">
          <FormattedMessage id="chlorophyll_splash_heading" />
        </h1>
        <p className="w-auto md:text-24 text-20">
          <FormattedMessage id="chlorophyll_splash_body" />
          <div className="mt-32">
            <button
              style={{ letterSpacing: '1.12px' }}
              onClick={() => onDismiss()}
              className="cursor-pointer bg-BrandNew text-TypeConstant uppercase text-14 font-demibold px-32 py-20 rounded-12"
            >
              <FormattedMessage id="chlorophyll_splash_go_to" />
            </button>
          </div>
        </p>
      </div>
      <div className="chlorophyll-splash-screen__footer flex-grow-0 bg-BrandDark w-full text-center p-32">
        <div className="text-14 uppercase font-bold mb-16">
          <FormattedMessage id="chlorophyll_splash_download" />
        </div>
        <AppButtons />
      </div>
    </div>
  </div>
)

export default ChlorophyllSplashScreen
